export const tilUtland = ['PM_OVERFORE_UTLAND_V2', 'BM_OVERFORE_UTLAND_V2'];

export const fraUtland = ['PM_MOTTA_UTLAND_V2', 'BM_MOTTA_UTLAND_V2'];

export const FRA_UTLAND_TYPE = 'FRA_UTLAND';
export const TIL_UTLAND_TYPE = 'TIL_UTLAND';
